export default __webpack_public_path__ + "static/media/Catálogo_tvs_neonx_110.78e3c30f.pdf";